import { render, staticRenderFns } from "./haokaByEx1.vue?vue&type=template&id=5423fe9b&scoped=true&"
import script from "./haokaByEx1.vue?vue&type=script&lang=js&"
export * from "./haokaByEx1.vue?vue&type=script&lang=js&"
import style0 from "./haokaByEx1.vue?vue&type=style&index=0&id=5423fe9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5423fe9b",
  null
  
)

export default component.exports